export default __webpack_public_path__ + "static/media/btn_registro.2a0e4904.png";